import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedValidationMessageComponent } from '../common/shared-validation-message/shared-validation-message.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { HeadlineService } from '../common/services/headline.service';
import { LoadingService } from '../common/services/loading.service';
import { SharedValidationService } from '../common/shared-validation.service';
import { EditTripComponent } from '../edit-trip/edit-trip.component';
import { DataService } from '../expense/receipt/data.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-archive-trip',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    SharedValidationMessageComponent,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    HttpClientModule,
    MatInputModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTabsModule,
  ],
  templateUrl: './archive-trip.component.html',
  styleUrls: ['./archive-trip.component.css']
})
export class ArchiveTripComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = [
    'id',
    'tripName',
    'organization',
    'user',
    'tripStart',
    'tripEnd',
    'tripDuration',
    'description',
    'unarchive',
  ];

  constructor(
    private ds: DataService,
    private fb: FormBuilder,
    private headlineService: HeadlineService,
    private sharedValidationService: SharedValidationService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private _httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private sanitizationService: DomSanitizer,
    public dialog: MatDialog
  ) {}
  trips = new MatTableDataSource<any>([]);
  loadingBlur: boolean = true;
  shouldShowPaginator:boolean=false
  async ngOnInit(): Promise<void> {
    if (this.isLoggedIn()) {
      this.headlineService.setHeadline('Archive Trips');
      await this.loadTrips();
    } else {
      this.snackBar.open('Please debug in first ', 'OK', {
        duration: 2000,
      });
      this.router.navigate(['/']);
    }
  }

  formatDate(date: string): string {
    return (
      this.datePipe.transform(new Date(date), 'yyyy-MM-dd HH:mm:ss') || 'N/A'
    );
  }



  unArchive(event: MouseEvent, id: string, etag: string) {
    event.stopPropagation();
    const trip = this.trips.data.find((trip: any) => trip._id == id);
    console.debug(trip)
    if (trip) {
      let tripData:any = {
        archive: false,
    };
    this.ds.updateTripDetail(id,tripData,etag).subscribe(
      (res)=>{
        console.debug(res)
        if (
          res &&
          res._status &&
          String(res._status).toLowerCase() === 'ok' &&
          res._success &&
          res._success.message
        ) {
          this._snackBar.open(
            'Trip-' +
            trip.trip_name
              +
              ' is Unarchived.',
            ''
          );
          this.router.navigate(['/trip'])
        } else {
          this._snackBar.open(
            'Trip-' +
            trip.trip_name
              +
              ' is Unarchived.',
            ''
          );
          this.router.navigate(['/trip'])
        }
      },
      (error:HttpErrorResponse)=>{
        console.debug(error.message)
        this._snackBar.open(
          'Error:::' +error.message
        );
      }
    )
    } else {
      console.error('Trip not found with id:', id, 'and etag:', etag);
    }
  }
  async loadTrips(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.ngxService.show()
      this.ds.getTrips(this.getUserIdFromLocal()).subscribe(
        (trips) => {
          console.debug(trips._items)
          this.trips = new MatTableDataSource(trips._items.filter(x=>x.archive===true));
          if(this.trips.data.length>0){
            this.shouldShowPaginator=true
          }
          this.trips.paginator = this.paginator;
          console.debug('Filtered trips:', this.trips);
          resolve();
        },
        (error) => {
          console.error('Error fetching trips details:', error);
          reject(error);
        },
        () => {
          console.debug('Observable completed');
          resolve();
          this.ngxService.hide()
          this.loadingBlur = false;
        }
      );
    });
  }

  getUserIdFromLocal(): string {
    var storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      var parsedResponse = JSON.parse(storedResponse);
      var userId = parsedResponse._items[0].user_id;
      console.debug(userId + ' localtorage');
      return userId;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }

  calculateTripDuration(startDate: Date, endDate: Date): number {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const duration = Math.abs(end.getTime() - start.getTime());
    const days = Math.ceil(duration / (1000 * 3600 * 24));
    return days;
  }

  

 
  // assignBillToTrip(tripId: string) {
  //   console.debug('tripId:::', tripId);
  //   this.router.navigate([`/trips/${tripId}`]);
  // }

  
  assignBillToTrip(tripId: string,org_id:string) {
    console.debug('tripId:::', tripId);
    this.router.navigate([`/trips/${tripId}`], { queryParams: { org_id: org_id} });
  }
  
  isLoggedIn(): boolean {
    return !!localStorage.getItem('currentUser');
  }
}
